import { mutex } from '~/domain/auth/utils/auth-lock';
import {
  handleNetworkError,
  parseJsonOrThrow,
  handleServerMaintenanceRedirect,
  handleNoSubscriptionException,
  returnIfOKOrThrow,
  handleAuth,
} from './middlewares/index';

const fetchWrapper = async <T>(req: Request): Promise<T> => {
  const requestClone = req.clone();
  await mutex.waitForUnlock();
  return fetch(req)
    .catch(handleNetworkError)
    .then((res) => handleAuth(res, requestClone))
    .then(parseJsonOrThrow)
    .then(handleServerMaintenanceRedirect)
    .then(handleNoSubscriptionException)
    .then(returnIfOKOrThrow);
};

export default fetchWrapper;
